/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  InfoOverlayContentInnerContainer
 */
/** @jsx jsx */

import { jsx } from '@emotion/react'
import type { AdditionalBuildingData, Listable } from '@zcode/state-type'
import { getDateAvailableText } from '../../helpers/getDateAvailableText'
import { getShowAmenitiesOrDescription } from '../../helpers/getShowAmenitiesOrDescription'
import { getVerticalSpecificDetail } from '../../helpers/getVerticalSpecificDetail'
import { trimStringToLength } from '../../helpers/trimStringToLength'
import { InfoOverlayContent } from './InfoOverlayContent'

export interface Props {
  additionalBuildingData?: AdditionalBuildingData
  isCFR?: boolean
  isLargeCard?: boolean
  isMobile?: boolean
  listable: Listable
  verticalsArray?: string[]
}

// const DESCRIPTION_MAX_LENGTH = 300
const VERTICAL_DETAIL_LENGTH = 85

export const InfoOverlayContentInnerContainer = ({
  additionalBuildingData,
  isCFR,
  isLargeCard,
  isMobile,
  listable,
  verticalsArray,
}: Props) => {
  const dateAvailableText = getDateAvailableText(listable)
  const verticalSpecificDetail = trimStringToLength(
    getVerticalSpecificDetail({
      listable,
      verticalsArray,
      additionalBuildingData,
    }) ?? undefined,
    VERTICAL_DETAIL_LENGTH
  )

  const { showAmenities, showShortDescription } = getShowAmenitiesOrDescription({ isCFR, listable })

  return (
    <InfoOverlayContent
      dateAvailableText={dateAvailableText}
      isLargeCard={isLargeCard}
      isMobile={isMobile}
      listable={listable}
      propertyType={listable.propertyType}
      shortDescriptionText={listable.shortDescription}
      showAmenities={showAmenities}
      showShortDescription={showShortDescription}
      verticalSpecificDetail={verticalSpecificDetail}
      verticalsArray={verticalsArray}
    />
  )
}
